(() => {
  'use strict';

  if (window.cartRecommendationsInitialized) return;
  window.cartRecommendationsInitialized = true;

  const ROOT_SELECTOR = '[data-ajax-main-cart]';
  const CONTROLS_SELECTOR = '[data-cart-recommendation-controls]';
  const ADD_BUTTON_SELECTOR = '[data-cart-recommendation-add]';

  const getRootUrl = () =>
    window.Shopify?.routes?.root || '/';

  const getCartAddUrl = () =>
    window.routes?.cart_add_url
      ? `${window.routes.cart_add_url}.js`.replace('.js.js', '.js')
      : `${getRootUrl()}cart/add.js`;

  const getCartUrl = () =>
    window.routes?.cart_url
      ? `${window.routes.cart_url}.js`.replace('.js.js', '.js')
      : `${getRootUrl()}cart.js`;

  const getVariantId = (controls) => {
    const select = controls.querySelector('.collection-variant-select');

    if (select) {
      return Number(select.value);
    }

    const singleVariant = controls.querySelector(
      '.collection-single-variant-data'
    );

    return Number(singleVariant?.dataset.variantId || 0);
  };

  const getQuantity = (controls) => {
    const input = controls.querySelector('.collection-quantity-input');
    return Math.max(1, Number.parseInt(input?.value || '1', 10));
  };

  const setMessage = (controls, message = '', isError = false) => {
    const messageElement = controls.querySelector(
      '.collection-form-message'
    );

    if (!messageElement) return;

    messageElement.textContent = message;
    messageElement.hidden = !message;
    messageElement.classList.toggle('is-error', isError);
    messageElement.classList.toggle(
      'is-success',
      Boolean(message) && !isError
    );
  };

  const updateCartCount = (itemCount) => {
    if (typeof itemCount !== 'number') return;

    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = itemCount;
      element.hidden = itemCount < 1;
    });

    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      const count =
        bubble.querySelector('span[aria-hidden="true"]') ||
        bubble.querySelector('span');

      if (count) count.textContent = itemCount;

      bubble.hidden = itemCount < 1;
      bubble.classList.toggle('hidden', itemCount < 1);
    });
  };

  const replaceMainCart = (currentRoot, sectionHtml) => {
    const parser = new DOMParser();
    const parsed = parser.parseFromString(sectionHtml, 'text/html');
    const updatedRoot = parsed.querySelector(ROOT_SELECTOR);

    if (!updatedRoot) {
      throw new Error('The refreshed cart section was not found.');
    }

    currentRoot.replaceWith(updatedRoot);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(ADD_BUTTON_SELECTOR);
    if (!button) return;

    event.preventDefault();

    const controls = button.closest(CONTROLS_SELECTOR);
    const root = button.closest(ROOT_SELECTOR);

    if (!controls || !root || button.disabled) return;

    const variantId = getVariantId(controls);
    const quantity = getQuantity(controls);
    const sectionId = root.dataset.sectionId;
    const buttonText = button.querySelector('.collection-button-text');
    const originalText = buttonText?.textContent.trim() || 'ADD TO CART';

    if (!variantId || !sectionId) {
      setMessage(
        controls,
        'The selected product could not be added.',
        true
      );
      return;
    }

    button.disabled = true;
    button.classList.add('is-loading');

    if (buttonText) buttonText.textContent = 'ADDING…';
    setMessage(controls);

    try {
      const formData = new FormData();
      formData.append('id', String(variantId));
      formData.append('quantity', String(quantity));
      formData.append('sections', sectionId);
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description ||
          result.message ||
          'The product could not be added.'
        );
      }

      const cartResponse = await fetch(getCartUrl(), {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const cart = await cartResponse.json();
      updateCartCount(cart.item_count);

      const updatedSection = result.sections?.[sectionId];

      if (!updatedSection) {
        throw new Error('The updated cart could not be rendered.');
      }

      replaceMainCart(root, updatedSection);

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart,
            item: result,
            source: 'cart-recommendations'
          }
        })
      );
    } catch (error) {
      console.error('Cart recommendation add error:', error);

      setMessage(
        controls,
        error?.message || 'Something went wrong. Please try again.',
        true
      );

      if (buttonText) buttonText.textContent = originalText;
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  });
})();
